import React from 'react';

import {
  ExecutionStatus,
} from '../components';

export function fmtExecutionStatus(execution) {
  return <ExecutionStatus execution={execution} adornment='end'/>;
}
